import React from 'react'
import PropTypes from 'prop-types'
import { FormGroup } from 'reactstrap'
import { Field } from 'redux-form'
import cn from 'classnames'
import FieldLabel from '../FieldLabel'
import './field-group.css'

const FieldGroup = ({
  name,
  title,
  required,
  disabled,
  hidden,
  ...props
}) => (
  <FormGroup className={cn({ 'form-group--hidden': hidden })}>
    {title && (
      <FieldLabel
        name={name}
        title={title}
        required={required}
      />
    )}
    <Field
      {...props}
      id={name}
      name={name}
      disabled={disabled}
    />
  </FormGroup>
)

FieldGroup.defaultProps = {
  required: false,
  disabled: false,
  hidden  : false,
  title   : undefined,
}

FieldGroup.propTypes = {
  name    : PropTypes.string.isRequired,
  title   : PropTypes.string,
  required: PropTypes.bool,
  disabled: PropTypes.bool,
  hidden  : PropTypes.bool,
}

export default FieldGroup
